import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { from, of, switchMap } from 'rxjs';
import { PricingService } from '../services/pricing.service';
import { StoryblokService } from '../services/storyblok.service';
import { containsComponent } from './storyblok-find-components';

export const storyblokBackendPricesResolver: ResolveFn<unknown> = route => {
  const pricingService = inject(PricingService);

  const path = route.url.map(segment => segment.path).join('/') || 'home';
  const storyBlockService = inject(StoryblokService);
  return storyBlockService.getStory(path, route).pipe(
    switchMap(resp => {
      const story = resp && resp.story;
      if (!story) return of(undefined);
      return storyBlockService.resolveRelationships(route).pipe(
        switchMap(relationships => {
          const componentTypes: unknown[] = ['PricingBoxList', 'ProductComparisonList', 'ProductComparison'];
          if (componentTypes.some(type => containsComponent([story.content, ...relationships], type))) {
            return from(pricingService.getPrices('main'));
          }
          return of(undefined);
        })
      );
    })
  );
};
